import './home.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import CartSidebar from '../components/CartSidebar.js';
import Products from '../components/Products.js'
import Categories from '../components/Categories.js'
import React, { useEffect } from 'react';

function Home() {
  useEffect(() => {
    document.title = "CryosphereComputing Shop"; // Set the title for the Home page
  }, []);

  return (
      <div className="container">
      <div className="row">
      </div>
        <div className="row">
        <div className="col-xs-12 col-lg-2 col-xl-2 categories">
        <Categories />
        </div>
        <div className="col-xs-12 col-lg-7  col-xl-7 product_grid">
          <Products />
        </div>
        <div className="col-xs-12 col-lg-3 col-xl-3 d-none d-xl-block sidebar">
        <CartSidebar />
        </div>
        </div>
      </div>
  )
}

export default Home